class SizeVariantSelector extends VariantSelector {
  constructor() {
    super();
    this.property = 'size';
    this.value = false;
    this.displayValue = false;
    this.unavailableLabel = this.getAttribute('unavailable-label');
    this.defaultLabel = this.getAttribute('default-label');
    this.formId = this.getAttribute('form-id');
    this.variantFontFamily = this.getAttribute('variant-font-family');

    this.options = [];
    this.wrapper = this.querySelector('.product-size-selector');
    this.tooltip = this.querySelector('.product-size-selector__tooltip');
    this.label = this.querySelector('.product-size-selector__label');
  }

  // This may be extended later to support hard-unavailable which would be OOS items.
  getAvailabilityClass(option) {
    return option.enabled ? '' : 'soft-unavailable';
  }

  setValue(value){
    // Escape quotes in value to prevent breaking the querySelector
    const formattedValue = value.replace(/"/g, '\\"').replace(/'/g, "\\'");
    super.setValue(formattedValue);
    const selected = this.querySelector(`[name="${this.property}-option"][value="${formattedValue}"`);
    selected.checked = true;
    this.updateLabel();
  }

  render() {
    const options = window.variants.getVariantData(this.property);
    let markup = '';

    options.forEach((value, index) => {
      const selectorID = `selector-${this.property}-${index}`;
      // Escape quotes in value to prevent breaking the html
      const formattedValue = value.value.replace(/"/g, '&quot;').replace(/'/g, '&apos;');
      const availClass = this.getAvailabilityClass(value);
      markup += `<input id="${selectorID}" type="radio" form="${this.formId}" name="${this.property}-option" value="${formattedValue}" class="p-small ${availClass}" selected="false" aria-disabled="${!value.enabled}" />
      <label for="${selectorID}" class="${this.variantFontFamily}">
        <span class="">${value.label}</span>
        <span class="visually-hidden sr-unavailable">${!value.enabled ? this.unavailableLabel : ''}</span>
        <svg><line x1="0" y1="98%" x2="100%" y2="2%"></line></svg>
      </label>`;
    });

    this.wrapper.insertAdjacentHTML('beforeend', markup);

    this.wrapper.classList.toggle('hidden', options.length === 0);

    /* Set options within inputs to enable event listener attachment to each child. */
    this.options = this.querySelectorAll('input[type="radio"]');

    this.options.forEach((element) => {
      element.addEventListener('click', (event) => {
        const state = this.getOptionState(element.value);

        if (state?.softUnavailable) {
          element.checked = true;
          this.handleSoftUnavailableClick(element.value);
          this.updateLabel();
          return;
        }

        // Available: normal selection
        this.onValueChanged();
      });
    });

    this.label.innerText = this.defaultLabel;
  }

  updateOptions(event){
    if (event.detail.property != this.property){
      const options = window.variants.getVariantData(this.property);

      for (var option in options){
        // Escape quotes in value to prevent breaking the querySelector
        const value = options[option].value.replace(/"/g, '\\"').replace(/'/g, "\\'");
        const input = this.querySelector(`input[value="${value}"]`);
        const label = input.nextElementSibling.querySelector('span.sr-unavailable');
        const availClass = this.getAvailabilityClass(options[option]);

        // Remove all availability classes before applying current state
        input.classList.remove('disabled', 'soft-unavailable');

        if (options[option].enabled){
          label.innerHTML = '';
        } else {
          input.classList.add(availClass);
          label.innerHTML = this.unavailableLabel;
        }
        input.setAttribute('aria-disabled', !options[option].enabled);
      }

      // Auto-select if only one option is available and nothing is selected
      if (!this.value) {
        const single = this.getSingleEnabledOption();
        if (single) {
          this.setValue(single.value);
          window.variants.setVariantOption(this.property, this.value);
        }
      }
    }
  }

  updateSelected(event) {
    if (event.detail.property == this.property){
      const selected = this.querySelector(`[name="${this.property}-option"][value="${event.detail.code}"]`);
      if (selected){
        selected.checked = true;
        this.updateLabel();
      }
    }
  }

  deselect() {
    super.deselect();
    this.label.innerText = this.defaultLabel;
  }

  updateLabel() {
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.displayValue = this.querySelector(`label[for="${selected.id}"] span:first-child`).textContent;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`
    this.label.innerHTML = this.displayValue;
  }

  onValueChanged(){
    const selected = this.querySelector(`[name="${this.property}-option"]:checked`);
    this.setValue(selected.value);
    window.variants.setVariantOption(this.property, this.value);
  }
}

customElements.define('size-variant-selector', SizeVariantSelector);
